// extracted by mini-css-extract-plugin
export var li = "_uk-2";
export var ol = "_uk-1";
export var ul = "_uk-0";